// src/app/shared/components/loader.component.ts
import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { LoaderService } from '../../services/loader.service';

@Component({
    selector: 'app-loader',
    imports: [CommonModule],
    template: `
    @if (loaderService.isLoading$ | async) {
      <div class="loader">Loading...</div>
    }
  `,
    styles: [
        `
      .loader {
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        /* Add your loader styles */
      }
    `,
    ]
})
export class LoaderComponent {
  constructor(public loaderService: LoaderService) {}
}
